<template>
  <div></div>
</template>

<script>
import CancelService from "@/services/CancelService";
export default {
  name: "CancellationDetailsComponent",
  props: ["cancel_booking_id"],
  data() {
    return {
      list: null,
      error: null,
      loading: true
    };
  },
  created: function() {
    CancelService.viewCancellationDetails({
      id: this.cancel_booking_id
    })
      .then(result => {
        this.list = result.data;
        this.loading = false;
      })
      .catch(err => {
        this.error = err.response.data.errors;
      });
  }
};
</script>

<style></style>
